(function ($) {
    $(function () {
        const userAgent = navigator.userAgent;
        const isIosDevice = (/iPad|iPhone|iPod/.test(userAgent));
        const isAndroidDevice = (/android/i.test(userAgent));

        if (isIosDevice) {
            $('.app-store-action-link').removeClass('vds-item-hidden');
        }
        else if (isAndroidDevice) {
            $('.google-play-action-link').removeClass('vds-item-hidden');
        }
        else {
            $('.app-store-action-link').removeClass('vds-item-hidden');
            $('.google-play-action-link').removeClass('vds-item-hidden');
        }
    });
})(window.jQuery);
